// CalendarContainer.js
import React from 'react';
import { Box, Typography, Grid } from '@mui/material';
import IntegrationItem from './IntegrationItem';
import { INTEGRATIONS_CONFIG } from 'config/integrationsConfig';
import { getIconComponent } from '../../utils/icons/iconUtils';

const CalendarContainer = ({ searchTerm = '' }) => {
    const filteredIntegrations = INTEGRATIONS_CONFIG['Calendar Booking'].filter(integration =>
        integration.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    if (filteredIntegrations.length === 0 && searchTerm) {
        return null;
    }

    return (
        <Box>
            <Typography
                variant="h5"
                sx={{
                    fontWeight: 600,
                    mb: 3,
                    color: '#242020'
                }}
            >
                Calendar Booking
            </Typography>
            <Typography
                variant="body1"
                sx={{
                    mb: 3,
                    color: '#828282'
                }}
            >
                Book more demos by connecting Touch to your calendar booking app
            </Typography>
            <Grid container spacing={2}>
                {filteredIntegrations.map((integration) => (
                    <Grid item xs={12} sm={6} md={3} key={integration.name}>
                        <IntegrationItem
                            text={integration.name}
                            icon={getIconComponent(integration.name)}
                            disabled={integration.disabled}
                            comingSoon={integration.comingSoon}
                        />
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default CalendarContainer;